var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconJpeg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91927 20.625V16.5M9.91927 16.5V12.375H14.1693V16.5H9.91927ZM22.6693 12.375H18.4193V20.625H22.6693M31.1693 12.375H26.9193V20.625H31.1693V17.325M5.66927 12.375V18.15C5.66927 20.625 2.83594 20.625 2.83594 20.625M18.4193 16.5H21.2526",
    stroke: "#2783EC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.67188 8.25V4.95C5.67187 4.7312 5.76143 4.52135 5.92083 4.36664C6.08024 4.21192 6.29644 4.125 6.52187 4.125H27.4885C27.714 4.125 27.9302 4.21192 28.0896 4.36664C28.249 4.52135 28.3385 4.7312 28.3385 4.95V8.25M5.67188 24.75V28.05C5.67187 28.2688 5.76143 28.4786 5.92083 28.6334C6.08024 28.7881 6.29644 28.875 6.52187 28.875H27.4885C27.714 28.875 27.9302 28.7881 28.0896 28.6334C28.249 28.4786 28.3385 28.2688 28.3385 28.05V24.75",
    stroke: "#2783EC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJpeg);
export default __webpack_public_path__ + "static/media/icon-jpeg.912112f02ddd6186577d4c0d0e15ab79.svg";
export { ForwardRef as ReactComponent };